// eslint-disable-next-line
export const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line
export const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/;
export const validUniEmailRegex = /(seventechnology.co.uk$|.ac.uk$|wearenova.co.uk$)/;
export const WebStorageNames = {
  UserInfo: "userInfo",
  AuthInfo: "authInfo",
  UserLoggedIn: "userLoggedIn"
};